import { useEffect, useRef } from 'react';
import { FADE, HIDE, FAST } from './const';
import { Sound } from './Sound';
import { isMobile, isSafari, isMobileSafari, isIOS } from 'react-device-detect';
import { get, set, del } from 'idb-keyval';

export const windowSize = () => {
  var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    x = w.innerWidth || e.clientWidth || g.clientWidth,
    y = w.innerHeight || e.clientHeight || g.clientHeight;

  return { x, y };
};

export const isOnMobile = () => {
  return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
};

export const delay = (fn, ms = FAST) => {
  return setTimeout(fn, ms);
};

export const hideLeaderboards = showLeaderboards => {
  showLeaderboards(FADE);
  delay(() => showLeaderboards(HIDE));
};

export const isNum = i => {
  return Number.isInteger(i);
};

export const getDate = () => {
  const d = new Date();
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1, 2, 0)}-${pad(d.getUTCDate(), 2, 0)}`;
};

const pad = (n, length, ch, end) => {
  const s = n.toString();
  return end ? s.padEnd(length, ch) : s.padStart(length, ch);
};

export const playSound = (props, name) => {
  Sound(name, props.globalOptions.volume);
};

export const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  // remember the latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // set up the interval
  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };

    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};

export const formatTime = secs => {
  secs = secs || 0;
  const mins = Math.floor(secs / 60);
  secs -= mins * 60;

  if (secs < 10) {
    secs = `0${secs}`;
  }

  return `${mins}:${secs}`;
};

export const scrollClass = `root-scroll ${isMobile ? 'root-scroll-mobile' : ''}`;

export const apple = isSafari || isMobileSafari || isIOS;

const iframe = window.frameElement || window.location !== window.parent.location || window.self !== window.top;

export const canUseLocalStorage = !apple || !iframe;
// export const canUseLocalStorage = false;

export const dbget = (key, resolve, reject) => {
  if (!canUseLocalStorage) {
    resolve();
    return false;
  }

  get(key)
    .then(value => resolve(value))
    .catch(err => reject(err));

  return true;
};

export const dbset = (key, value, resolve) => {
  if (!canUseLocalStorage) {
    resolve && resolve();
    return false;
  }

  set(key, value).then(resolve);
  return true;
};

export const dbdel = key => {
  if (!canUseLocalStorage) {
    return false;
  }

  del(key);
  return true;
};
